export function isUsbTransferError(error: any): boolean {
    const errorStr = `${error}`;
    return (
        errorStr.includes('transferIn') ||
        errorStr.includes('transferOut') ||
        errorStr.includes('transfer error') ||
        errorStr.includes('NetworkError')
    );
}
